import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { DIALOG_CLOSE_BUTTON_SX } from "../../../constants/dialogCloseButtonStyles";
import { withoutBackdropClose } from "../../../utils/withoutBackdropClose";
import {
  AUTO_TAGGING_CONFIRM_CANCEL_BUTTON_SX,
  AUTO_TAGGING_CONFIRM_CONFIRM_BUTTON_SX,
  AUTO_TAGGING_CONFIRM_DIALOG_BODY_SX,
  AUTO_TAGGING_CONFIRM_DIALOG_PAPER_SX,
  AUTO_TAGGING_CONFIRM_DIALOG_TITLE_SX,
} from "../autoTaggingConfirmDialogStyles";

type DiscardEnhancedTaggingRuleChangesDialogProps = Readonly<{
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}>;

export default function DiscardEnhancedTaggingRuleChangesDialog({
  open,
  onCancel,
  onConfirm,
}: DiscardEnhancedTaggingRuleChangesDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={withoutBackdropClose(onCancel)}
      maxWidth={false}
      PaperProps={{ sx: AUTO_TAGGING_CONFIRM_DIALOG_PAPER_SX }}
    >
      <DialogTitle sx={AUTO_TAGGING_CONFIRM_DIALOG_TITLE_SX}>
        Discard Changes?
        <IconButton
          aria-label="Close"
          onClick={onCancel}
          sx={DIALOG_CLOSE_BUTTON_SX}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0, pb: 1 }}>
        <Typography sx={AUTO_TAGGING_CONFIRM_DIALOG_BODY_SX}>
          Once canceled, you cannot recover the configuration. Are you sure you
          want to continue?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          variant="text"
          onClick={onCancel}
          sx={AUTO_TAGGING_CONFIRM_CANCEL_BUTTON_SX}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={AUTO_TAGGING_CONFIRM_CONFIRM_BUTTON_SX}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
